/** @lint */

/**
 * @module orb/features/_skiplinks
 */
define('orb/features/_skiplinks', [], function () {
  'use strict';

  /**
        Fix skip links in Webkit.
        @author Ian Pouncey
     */
  return function () {
    function ready() {
      var accLinks = document.querySelector('.orb-skip-links');
      if (!accLinks) {
        return;
      }

      var clickHandler = function (e) {
        //needed? e = e || window.event;
        var target = e.target || e.srcElement,
            hash = target.getAttribute('href').match(/^(#.+)/);

        if (hash) {
          var targetElement = document.querySelector(hash[1]);
          if (
            targetElement.tabIndex === null ||
              targetElement.tabIndex === -1
          ) {
            // some browser mistakenly reports -1 when it is unset,  so set to -1 explicitly in that case
            targetElement.tabIndex = -1;
          }
          targetElement.focus();
        }
      };
      accLinks.addEventListener('click', clickHandler);
    }

    if (document.readyState != 'loading') {
      ready();
    } else {
      document.addEventListener('DOMContentLoaded', ready);
    }
  };
});
